const TokenKey = "SosPortal-Token";
const TokenExpriedMinsKey = "SosPortal-TokenExpriedMins";
const RefreshTokenKey = "SosPortal-RefreshToken";
const RefreshTokenExpriedMinsKey = "SosPortal-RefreshTokenExpriedMins";
const UserInfo = "SosPortal-UserInfo";
const UserCode = "SosPortal-UserCode";
const Login = "SosPortal-Login";
const LoginSource = "SosPortal-LoginSource";
const RememberToken = "remember_token";

import Cookies from 'js-cookie'
//token (string, optional): token ,
export function getToken() {
  return sessionStorage.getItem(TokenKey);
}
export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token);
}
export function removeToken() {
  return sessionStorage.removeItem(TokenKey);
}

//tokenExpriedMins (string, optional): token有效期（单位：分钟）
export function getTokenExpriedMins() {
  return sessionStorage.getItem(TokenExpriedMinsKey);
}
export function setTokenExpriedMins(tokenExpriedMins) {
  return sessionStorage.setItem(TokenExpriedMinsKey, tokenExpriedMins);
}
export function removeTokenExpriedMins() {
  return sessionStorage.removeItem(TokenExpriedMinsKey);
}

//refreshToken (string, optional): 刷新Token ,
export function getRefreshToken() {
  return sessionStorage.getItem(RefreshTokenKey);
}
export function setRefreshToken(refreshToken) {
  return sessionStorage.setItem(RefreshTokenKey, refreshToken);
}
export function removeRefreshToken() {
  return sessionStorage.removeItem(RefreshTokenKey);
}

//refreshTokenExpriedMins (string, optional): 刷新token有效期（单位：分钟） ,
export function getRefreshTokenExpriedMins() {
  return sessionStorage.getItem(RefreshTokenExpriedMinsKey);
}
export function setRefreshTokenExpriedMins(refreshTokenExpriedMins) {
  return sessionStorage.setItem(RefreshTokenExpriedMinsKey, refreshTokenExpriedMins);
}
export function removeRefreshTokenExpriedMins() {
  return sessionStorage.removeItem(RefreshTokenExpriedMinsKey);
}
export function storeLoginSource(loginSource) {
  return sessionStorage.setItem(LoginSource, loginSource);
}
//时间定时器
export function setItem(key, value) {
  value = JSON.stringify(value);
  sessionStorage.setItem(key, value)
}

export function getItem(key, defaultValue) {
  let value = sessionStorage.getItem(key)
  value = JSON.parse(value);
  return value || defaultValue
}

export function removeItem(key) {
  sessionStorage.removeItem(key)
}
//
// export function clear() {
//   sessionStorage.clear()
// }

//UserInfo
// export function getUserInfo() {
//   return sessionStorage.getItem(UserInfo);
// }
export function setUserInfo(userInfo) {
  return sessionStorage.setItem(UserInfo, userInfo);
}
// export function removeUserInfo() {
//   return sessionStorage.removeItem(UserInfo);
// }

//userCode
export function getUserCode() {
  return sessionStorage.getItem(UserCode);
}
export function setUserCode(userCode) {
  return sessionStorage.setItem(UserCode, userCode);
}
export function removeUserCode() {
  return sessionStorage.removeItem(UserCode);
}

export function removeStorage() {
  removeToken();
  removeTokenExpriedMins();
  removeRefreshToken();
  removeRefreshTokenExpriedMins();
  removeItem();
  removeUserCode();

  Cookies.remove("userCode");
  Cookies.remove("userPwd");
  Cookies.remove("rememberFlag");
  removeRememberToken();
}

//remember_token（记住我，SM4密文，有效期7天）
export function getRememberToken() {
  return Cookies.get(RememberToken);
}
export function setRememberToken(rememberToken) {
  return Cookies.set(RememberToken, rememberToken, { expires: 7 });
}
export function removeRememberToken() {
  return Cookies.remove(RememberToken);
}

//仅清sessionStorage登录信息，保留remember_token cookie（供登录页自动登录逻辑接管）
export function clearSession() {
  removeToken();
  removeTokenExpriedMins();
  removeRefreshToken();
  removeRefreshTokenExpriedMins();
  removeItem();
  removeUserCode();
}

//判断JWT token是否已过期（解码payload取exp，毫秒时间戳），解析异常按过期处理
export function isTokenExpired(token) {
  if (!token) {
    return true;
  }
  try {
    const parts = token.split(".");
    if (parts.length < 2) {
      return true;
    }
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(
      decodeURIComponent(
        Array.prototype.map
          .call(atob(base64), (c) => {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      )
    );
    if (!payload.exp) {
      return true;
    }
    //兼容exp为秒或毫秒两种格式（本项目jjwt生成毫秒）
    const expMs = payload.exp < 1e12 ? payload.exp * 1000 : payload.exp;
    return Date.now() > expMs;
  } catch (e) {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js